import apiClient from '../apiClient';
import { POST_USER_PROFILE_ACTIVATE_URL } from '../apiUrl';

const postUserProfileActivateApi = Id => {
  return apiClient.post(POST_USER_PROFILE_ACTIVATE_URL(Id));
};

export default postUserProfileActivateApi;
